<div class="flex flex-col gap-5">

    <!-- lead callout -->
    <div class="flex gap-3.5 rounded-xl border border-brand-studio bg-brand-studio/10 p-4">
        <span class="grid size-10 shrink-0 place-items-center rounded-full bg-brand-studio text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <path d="m22 22-5.5-5.5" />
                <path d="M3 11a8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8 8 8 0 0 0-8 8Z" />
                <path d="M8 11h6" />
            </svg>
        </span>
        <div>
            <p class="m-0 font-heading text-[17px] font-bold text-foreground">Tell us what disqualifies a creator</p>
            <p class="m-0 mt-1 text-[13px] leading-relaxed text-foreground/80">
                A red flag is anything in a creator's content that makes them a bad fit for the ambassador programme.
                Answer the categories below — or add your own.
            </p>
        </div>
    </div>

    <!-- search -->
    <div class="relative flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="pointer-events-none absolute left-3.5 text-muted-foreground" aria-hidden="true">
            <path d="m21 21-4.34-4.34" />
            <circle cx="11" cy="11" r="8" />
        </svg>
        <input type="search" [value]="query()" (input)="setQuery($any($event.target).value)"
            aria-label="Search restriction types" placeholder="Search restriction types — e.g. alcohol, clothing…"
            class="w-full rounded-md border border-border bg-card py-2.5 pl-10 pr-11 text-sm outline-none focus:border-brand-studio focus:ring-2 focus:ring-brand-studio/25 placeholder:text-muted-foreground [&::-webkit-search-cancel-button]:hidden" />
        @if (query()) {
        <button type="button" (click)="clearQuery()" aria-label="Clear search"
            class="absolute right-2.5 grid size-[26px] place-items-center rounded-full bg-muted text-foreground/80 transition-colors hover:bg-muted-foreground/25 hover:text-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
            </svg>
        </button>
        }
    </div>
    <p class="sr-only" role="status" aria-live="polite">{{ matchCount() }} restriction types match</p>

    <!-- browse & build -->
    @if (activeCategory(); as category) {
    <div class="grid gap-4 md:grid-cols-[210px_1fr]">

        <!-- category rail -->
        <div class="flex flex-col gap-1.5" role="tablist" aria-label="Restriction types">
            @for (item of visibleCategories(); track item.id) {
            <button type="button" role="tab" [attr.aria-selected]="item.id === category.id"
                (click)="selectCategory(item.id)"
                class="flex items-center gap-3 rounded-md border-[1.5px] p-3 text-left transition-all"
                [class]="item.id === category.id ? 'border-brand-studio bg-brand-studio/10' : 'border-border bg-card hover:border-foreground/30'">
                <span class="grid size-8 shrink-0 place-items-center rounded transition-colors"
                    [class]="item.id === category.id ? 'bg-brand-studio text-white' : 'bg-muted text-muted-foreground'">
                    @switch (item.icon) {
                    @case ('wine') {
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <path d="M8 22h8" />
                        <path d="M7 10h10" />
                        <path d="M12 15v7" />
                        <path d="M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z" />
                    </svg>
                    }
                    @case ('image') {
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                        <circle cx="9" cy="9" r="2" />
                        <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
                    </svg>
                    }
                    @case ('shirt') {
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z" />
                    </svg>
                    }
                    @case ('tag') {
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
                        <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
                    </svg>
                    }
                    }
                </span>
                <span class="min-w-0 flex-1 font-heading text-sm font-bold leading-tight text-foreground">{{ item.label
                    }}</span>
                @if (countFor(item.id)) {
                <span
                    class="grid min-w-5 place-items-center rounded-full bg-brand-studio px-1.5 text-[11px] font-bold text-white">{{
                    countFor(item.id) }}</span>
                }
            </button>
            }
        </div>

        <!-- question panel -->
        <div class="rounded-xl border-[1.5px] border-border bg-card p-5 shadow-sm" role="tabpanel">
            <p class="m-0 font-heading text-lg font-bold tracking-tight text-foreground">{{ category.question }}</p>
            <p class="m-0 mb-3.5 mt-1 text-[13px] leading-relaxed text-muted-foreground">{{ category.prompt }}</p>

            @if (visibleEnrichments().length) {
            <div class="flex flex-wrap gap-2">
                @for (enrichment of visibleEnrichments(); track enrichment) {
                <button type="button" [attr.aria-pressed]="isOn(category.id, enrichment)"
                    (click)="toggle(category, enrichment)"
                    class="inline-flex select-none items-center gap-2 rounded-full border-[1.5px] px-3.5 py-2 text-sm font-medium transition-all"
                    [class]="isOn(category.id, enrichment) ? 'border-brand-studio bg-brand-studio text-white' : 'border-border bg-card text-foreground hover:border-foreground/30'">
                    @if (isOn(category.id, enrichment)) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                        aria-hidden="true">
                        <path d="M20 6 9 17l-5-5" />
                    </svg>
                    } @else {
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="opacity-55" aria-hidden="true">
                        <path d="M5 12h14" />
                        <path d="M12 5v14" />
                    </svg>
                    }
                    {{ enrichment }}
                </button>
                }
            </div>
            } @else {
            <p class="m-0 text-[13px] text-muted-foreground">No matching rules in this category.</p>
            }
        </div>
    </div>
    } @else {
    <div class="rounded-xl border-[1.5px] border-border bg-card p-5 text-center shadow-sm">
        <p class="m-0 inline-flex items-center gap-2.5 text-[13px] text-muted-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <path d="m13.5 8.5-5 5" />
                <path d="m8.5 8.5 5 5" />
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.3-4.3" />
            </svg>
            No restriction types match “{{ query().trim() }}”.
        </p>
    </div>
    }

    <sbs-screening-nogo-list />
</div>
